import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import { useUserActions } from "../store";
import type { LoginData } from "../types";

export function useLoginMutation() {
  const { setToken } = useUserActions();

  return useMutation({
    mutationFn: (payload: LoginData) => authApi.login(payload),
    onSuccess: (response) => {
      setToken(response.token);
    },
  });
}
